import Image from 'next/image';
import type { UiLogoProps } from './UiLogo.types';
import { cn } from '@/lib/tailwind';

function UiLogo({ className, alt = 'Immogschichten', eager }: UiLogoProps) {
    const src = '/logos/logo_immogschichten_80px.jpg';

    return (
        <div className={cn('relative w-16 h-full', className)}>
            <Image
                src={src}
                alt={alt}
                className="object-contain"
                sizes="64px"
                loading={eager ? 'eager' : undefined}
                fill
            />
        </div>
    );
}
export default UiLogo;
